var component = require('../../../lib/js/component.js');
var utils = require('../../../lib/js/utils.js');
var FOCUSABLE_SELECTOR = '.PromotionsPopup__close, .PromotionsPopup__cta';
var KEYBOARD_CLASS = 'is-keyboard-navigation';
var STORAGE_PREFIX = 'popup';
var ONE_MONTH_IN_MS = 30 * 24 * 60 * 60 * 1000;
var DISCLAIMER_TRIGGER_SELECTOR = '.PromotionsPopup__disclaimer-trigger';
var CTA_SELECTOR = '.PromotionsPopup__cta';
var TOOLTIP_SELECTOR = '.PromotionsPopup__tooltip';
var DOCUMENT_EVENT_NAMESPACE = '.PromotionsPopup';

function PromotionsPopup() {
    this.initialize = function () {
        this.$cta = this.$element.find(CTA_SELECTOR);
        this.$disclaimerTrigger = this.$element.find(DISCLAIMER_TRIGGER_SELECTOR);
        this.shouldRestoreFocus = false;
        this.bindEvents();

        this.$element.modal({
            backdrop: true,
            keyboard: true,
            show: false
        });

        this.showIfNeeded();
    };

    this.bindEvents = function () {
        this.$element.on('shown.bs.modal', this.handleShown.bind(this));
        this.$element.on('hidden.bs.modal', this.handleHidden.bind(this));
        this.$element.on('keydown', this.handleKeydown.bind(this));
        this.$element.on('mousedown touchstart', this.handlePointerInteraction.bind(this));

        if (this.$cta.length) {
            this.$cta.on('click', this.handleCtaClick.bind(this));
        }

        if (this.$disclaimerTrigger.length) {
            this.$disclaimerTrigger.on('click', this.handleDisclaimerTriggerClick.bind(this));
            $(document).off(DOCUMENT_EVENT_NAMESPACE);
            $(document).on('mousedown' + DOCUMENT_EVENT_NAMESPACE + ' touchstart' + DOCUMENT_EVENT_NAMESPACE, this.handleDocumentPointer.bind(this));
        }
    };

    this.showIfNeeded = function () {
        var storageKey = this.getStorageKey();

        if (this.hasSeenPopup(storageKey)) {
            return;
        }

        this.markPopupSeen(storageKey);
        this.$element.modal('show');
    };

    this.getStorageKey = function () {
        var pageType = this.slugify(this.$element.data('pageType') || 'page');
        var popupId = this.slugify(this.$element.data('promotionsPopupId'));
        var pathSegments = window.location.pathname.split('/');
        var pageSlug = 'page';
        var keyParts;

        for (var i = pathSegments.length - 1; i >= 0; i--) {
            pageSlug = this.slugify(pathSegments[i]);

            if (pageSlug) {
                break;
            }
        }

        keyParts = [STORAGE_PREFIX, pageType || 'page', pageSlug || 'page'];

        if (popupId) {
            keyParts.push(popupId);
        }

        return keyParts.join('-');
    };

    this.slugify = function (value) {
        return String(value || '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    };

    this.hasSeenPopup = function (storageKey) {
        var storedValue;
        var expiresAt;

        storedValue = this.getStoredPopupValue(storageKey);

        if (!storedValue) {
            return false;
        }

        try {
            expiresAt = this.getStoredPopupExpiration(storedValue);
        }
        catch (e) {
            this.clearStoredPopupValue(storageKey);
            return false;
        }

        if (!expiresAt || expiresAt <= Date.now()) {
            this.clearStoredPopupValue(storageKey);
            return false;
        }

        return true;
    };

    this.markPopupSeen = function (storageKey) {
        var expiresAt;

        expiresAt = this.getExpirationTimestamp();

        if (!this.supportsLocalStorage()) {
            this.writePopupSeenCookie(storageKey, expiresAt);
            return;
        }

        try {
            window.localStorage.setItem(storageKey, JSON.stringify({
                expiresAt: expiresAt
            }));
        }
        catch (e) {
            this.writePopupSeenCookie(storageKey, expiresAt);
        }
    };

    this.getStoredPopupValue = function (storageKey) {
        if (this.supportsLocalStorage()) {
            try {
                return window.localStorage.getItem(storageKey);
            }
            catch (e) {
                // Fall back to cookies for browsers such as Safari private mode.
            }
        }

        return utils.getCookie(storageKey);
    };

    this.getStoredPopupExpiration = function (storedValue) {
        var parsedValue;
        var parsedNumber;

        try {
            parsedValue = JSON.parse(storedValue);

            if (parsedValue && parsedValue.expiresAt) {
                return Number(parsedValue.expiresAt);
            }
        }
        catch (e) {
            parsedNumber = Number(storedValue);

            if (isFinite(parsedNumber) && parsedNumber > 0) {
                return parsedNumber;
            }

            throw e;
        }

        return NaN;
    };

    this.writePopupSeenCookie = function (storageKey, expiresAt) {
        var daysUntilExpiry;

        if (!isFinite(expiresAt) || expiresAt <= Date.now()) {
            return;
        }

        daysUntilExpiry = (expiresAt - Date.now()) / ONE_MONTH_IN_MS * 30;
        utils.setCookie(storageKey, String(expiresAt), daysUntilExpiry);
    };

    this.clearStoredPopupValue = function (storageKey) {
        if (this.supportsLocalStorage()) {
            try {
                window.localStorage.removeItem(storageKey);
            }
            catch (e) {
                // Ignore storage cleanup failures and clear the cookie fallback.
            }
        }

        utils.setCookie(storageKey, '', -1);
    };

    this.getExpirationTimestamp = function () {
        var endDate = this.$element.data('endDate');
        var parsedEndDate = Number(endDate);

        if (isFinite(parsedEndDate) && parsedEndDate > 0) {
            return parsedEndDate;
        }

        return Date.now() + ONE_MONTH_IN_MS; // Default to 30 days if no valid end date is provided
    };

    this.supportsLocalStorage = function () {
        try {
            return typeof window.localStorage !== 'undefined';
        }
        catch (e) {
            return false;
        }
    };

    this.handleShown = function () {
        var $focusableElements = this.getFocusableElements();

        this.shouldRestoreFocus = false;

        this.$element.attr('aria-hidden', 'false');

        if ($focusableElements.length) {
            $focusableElements.first().trigger('focus');
        }
    };

    this.handleHidden = function () {
        var target;

        this.hideDisclaimerTooltip();

        if (this.shouldRestoreFocus) {
            target = document.querySelector('a.Icon.Icon--logo[href="/"], a.SiteLogo[href="/"]');

            if (target) {
                target.focus();
            }
        }

        this.shouldRestoreFocus = false;

        this.$element
            .attr('aria-hidden', 'true')
            .removeClass(KEYBOARD_CLASS);
    };

    this.getFocusableElements = function () {
        return this.$element
            .find(FOCUSABLE_SELECTOR)
            .filter(':visible');
    };

    this.handlePointerInteraction = function () {
        this.shouldRestoreFocus = false;
        this.$element.removeClass(KEYBOARD_CLASS);
    };

    this.handleCtaClick = function (e) {
        var $cta;
        var ctaUrl;
        var ctaTarget;
        var validatedCtaUrl;
        var newWindow;

        $cta = $(e.currentTarget);
        ctaUrl = $cta.data('ctaUrl');
        ctaTarget = $cta.data('ctaTarget');

        if (!ctaUrl) {
            return;
        }

        e.preventDefault();

        validatedCtaUrl = this.getValidatedCtaUrl(ctaUrl);

        if (!validatedCtaUrl) {
            return;
        }

        newWindow = window.open(validatedCtaUrl, ctaTarget);

        if (newWindow) {
            newWindow.opener = null;
        }
    };

    this.getValidatedCtaUrl = function (ctaUrl) {
        var normalizedUrl;
        var parsedUrl;

        if (!ctaUrl) {
            return null;
        }

        normalizedUrl = String(ctaUrl).trim();

        if (!normalizedUrl) {
            return null;
        }

        if (normalizedUrl.charAt(0) === '/') {
            return normalizedUrl;
        }

        try {
            parsedUrl = new URL(normalizedUrl, window.location.origin);
        }
        catch (error) {
            return null;
        }

        if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
            return parsedUrl.href;
        }

        return null;
    };

    this.handleDisclaimerTriggerClick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.isDisclaimerTooltipOpen()) {
            this.hideDisclaimerTooltip();
            return;
        }

        this.showDisclaimerTooltip();
    };

    this.handleDocumentPointer = function (e) {
        var $target;

        if (!this.isDisclaimerTooltipOpen()) {
            return;
        }

        $target = $(e.target);

        if ($target.closest(DISCLAIMER_TRIGGER_SELECTOR).length || $target.closest(TOOLTIP_SELECTOR).length) {
            return;
        }

        this.hideDisclaimerTooltip();
    };

    this.showDisclaimerTooltip = function () {
        if (!this.$disclaimerTrigger.length) {
            return;
        }

        this.$disclaimerTrigger
            .tooltip('show')
            .attr('aria-expanded', 'true');

        // Move focus into the scrollable tooltip so keyboard-only users can scroll
        // the (now up to 2000-char) disclaimer. The tooltip is appended to <body>,
        // outside the modal's focus trap, so it must be focused programmatically.
        this.focusDisclaimerTooltip();
    };

    this.hideDisclaimerTooltip = function () {
        var activeElement;

        if (!this.$disclaimerTrigger.length) {
            return;
        }

        activeElement = document.activeElement;

        this.$disclaimerTrigger
            .tooltip('hide')
            .attr('aria-expanded', 'false');

        // Return focus to the trigger only when focus was inside the tooltip we just
        // removed and the trigger is still on screen (i.e. not when the modal itself
        // is closing), so keyboard users aren't dropped to the top of the document.
        if (activeElement &&
            $(activeElement).closest(TOOLTIP_SELECTOR).length &&
            this.$disclaimerTrigger.is(':visible')) {
            this.$disclaimerTrigger.trigger('focus');
        }
    };

    this.getDisclaimerTooltipInner = function () {
        var tooltipId = this.$disclaimerTrigger.attr('aria-describedby');

        if (!tooltipId) {
            return $();
        }

        return $('#' + tooltipId).find('.tooltip-inner');
    };

    this.focusDisclaimerTooltip = function () {
        var $inner = this.getDisclaimerTooltipInner();

        if (!$inner.length) {
            return;
        }

        $inner
            .off('keydown' + DOCUMENT_EVENT_NAMESPACE)
            .on('keydown' + DOCUMENT_EVENT_NAMESPACE, this.handleTooltipKeydown.bind(this))
            .trigger('focus');
    };

    this.handleTooltipKeydown = function (e) {
        if (e.key === 'Escape') {
            e.preventDefault();
            this.hideDisclaimerTooltip();
            return;
        }

        // The tooltip is appended to <body>, outside the modal's Tab trap. Closing it
        // on Tab and returning focus to the trigger keeps focus inside the modal and
        // hands navigation back to the modal's own focus management.
        if (e.key === 'Tab') {
            e.preventDefault();
            this.hideDisclaimerTooltip();
        }
    };

    this.isDisclaimerTooltipOpen = function () {
        return this.$disclaimerTrigger.length && !!this.$disclaimerTrigger.attr('aria-describedby');
    };

    this.handleKeydown = function (e) {
        var $focusableElements;
        var firstFocusableElement;
        var lastFocusableElement;

        this.shouldRestoreFocus = true;

        if (e.key === 'Escape' && this.isDisclaimerTooltipOpen()) {
            this.hideDisclaimerTooltip();
            return;
        }

        if (e.key !== 'Tab') {
            return;
        }

        this.$element.addClass(KEYBOARD_CLASS);

        $focusableElements = this.getFocusableElements();

        if (!$focusableElements.length) {
            e.preventDefault();
            return;
        }

        firstFocusableElement = $focusableElements[0];
        lastFocusableElement = $focusableElements[$focusableElements.length - 1];

        if (e.shiftKey && e.target === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
            return;
        }

        if (!e.shiftKey && e.target === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
        }
    };
}

module.exports = component(PromotionsPopup);
